import { h } from "preact";
import { useContext, useState } from "preact/hooks";
import { useLocation, Link } from "react-router-dom";
import { Layout, Divider, Menu } from "antd";
import { KeycloakContext } from "../../providers/KeycloakContext";

import BarChartOutlined from "../../assets/icons/BarChartOutlined";
import MembersOutlined from "../../assets/icons/MembersOutlined";
import SettingOutlined from "../../assets/icons/SettingsOutlined";
import UserOutlined from "../../assets/icons/UserOutlined";
import FileListOutlined from "../../assets/icons/FileListOutlined";
import LogoutOutlined from "../../assets/icons/LogoutOutlined";
import ChatOutlined from "../../assets/icons/ChatSmileOutlined";
import ExternalLinkOutlined from "../../assets/icons/ExternalLinkOutlined";
import Logo from "../../assets/img/logo/Logo";

export default function Sidebar({ sidebarOpen }) {
  const { keycloakClient } = useContext(KeycloakContext);
  const { pathname } = useLocation();
  const [selectedItem, setSelectedItem] = useState(pathname);
  const VERSION = "v" + process.env.APP_VERSION;
  const onLogout = () => keycloakClient.logout();

  return (
    <Layout.Sider
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        top: 0,
        left: 0,
      }}
      className={`sidebar${sidebarOpen ? " sidebar--open" : ""}`}
      theme="dark"
    >
      <div className="sidebar__logo">
        <Logo />
      </div>
      <div className="sidebar__menu">
        <div className="sidebar-menu__top">
          <Menu
            mode="inline"
            theme="dark"
            selectedKeys={[selectedItem]}
            onSelect={({ key }) => setSelectedItem(key)}
          >
            {/* <Menu.Item key="dashboard">
              <Link to="/" className="sidebar__menu__link">
                <BarChartOutlined />
                <span className="ant-menu-title-content">Dashboard</span>
              </Link>
            </Menu.Item> */}
            <Menu.Item key="transactions">
              <Link to="/transactions" className="sidebar__menu__link">
                <FileListOutlined />
                <span className="ant-menu-title-content">Transactions</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="flows">
              <Link to="/flows" className="sidebar__menu__link">
                <FileListOutlined />
                <span className="ant-menu-title-content">Flows</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="blacklist">
              <Link to="/blacklist" className="sidebar__menu__link">
                <BarChartOutlined />
                <span className="ant-menu-title-content">Blacklist</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="members" disabled>
              <Link
                to="/members"
                className="sidebar__menu__link"
                style={{
                  pointerEvents: "none",
                  color: "gray",
                  textDecoration: "none",
                }}
                disabled
              >
                <MembersOutlined />
                <span className="ant-menu-title-content">Members</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="settings">
              <Link to="/settings" className="sidebar__menu__link">
                <SettingOutlined />
                <span className="ant-menu-title-content">Settings</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="fpe">
              <Link to="/fpe" className="sidebar__menu__link">
                <SettingOutlined />
                <span className="ant-menu-title-content">Anti-Fraud Settings</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="account">
              <Link
                to="/account"
                className="sidebar__menu__link"
                // style={{
                //   pointerEvents: "none",
                //   color: "gray",
                //   textDecoration: "none",
                // }}
                // disabled
              >
                <UserOutlined />
                <span className="ant-menu-title-content">Account</span>
              </Link>
            </Menu.Item>
          </Menu>

          <Divider className="sidebar__divider" />

          <Menu
            mode="inline"
            theme="dark"
            selectedKeys={[selectedItem]}
            onSelect={({ key }) => setSelectedItem(key)}
          >
            <Menu.Item key="/client/documentation">
              <Link
                to="/documentation"
                className="sidebar__menu__link"
                target="_blank"
              >
                <FileListOutlined />
                <span className="ant-menu-title-content">Documentation</span>
                <ExternalLinkOutlined />
              </Link>
            </Menu.Item>
            {/* <Menu.Item key="/client/support" data-tour="support">
              <Link
                to="/support"
                className="sidebar__menu__link"
                target="_blank"
              >
                <ChatOutlined />
                <span className="ant-menu-title-content">Support</span>
                <ExternalLinkOutlined />
              </Link>
            </Menu.Item> */}
          </Menu>
        </div>

        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[selectedItem]}
          onSelect={onLogout}
        >
          <Menu.Item key="logout">
            <span className="sidebar__menu__link">
              <LogoutOutlined />
              <span className="ant-menu-title-content">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
        <div className="sidebar__version">
          {VERSION}
        </div>
        {/* <div className="sidebar-menu__bottom">
        </div> */}
      </div>
    </Layout.Sider>
  );
}
